import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { api, i18n } from "@/lib/api";

export default function MorningBriefing({ language }) {
  const t = i18n[language];
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const refresh = async () => {
    setBusy(true);
    setError("");
    try {
      const r = await api.briefingToday();
      setData(r);
    } catch (e) {
      setError(e?.response?.data?.detail || "Briefing unavailable");
    } finally {
      setBusy(false);
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  return (
    <div data-testid="morning-briefing">
      <div style={{ display: "flex", alignItems: "baseline", justifyContent: "space-between" }}>
        <div>
          <div className="h-eyebrow">{t.briefing}</div>
          <h2 className="h-display" style={{ fontSize: "1.3rem", margin: "0.35rem 0" }}>
            {new Date().toLocaleDateString(language === "es" ? "es-ES" : "en-US", { weekday: "long", month: "long", day: "numeric" })}
          </h2>
        </div>
        <button data-testid="briefing-refresh" className="btn-link" onClick={refresh} disabled={busy}>
          {busy ? "..." : (language === "es" ? "Actualizar" : "Refresh")}
        </button>
      </div>
      <div className="line" />
      {busy && <p className="txt-mute live-dot" data-testid="briefing-loading">{t.submitting}</p>}
      {error && <p className="txt-danger" data-testid="briefing-error">{error}</p>}
      {data && (
        <article className="markdown-body" data-testid="briefing-body">
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{data.markdown || ""}</ReactMarkdown>
        </article>
      )}
    </div>
  );
}
